<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 245 244" style="enable-background:new 0 0 245 244;" xml:space="preserve">    
    <circle class="st0" cx="122.6" cy="122" r="122"/>
    <g>
      <path class="st1" d="M123.4,123.7c-29.6,0-54.1,21.7-58.4,50.1c-0.7,4.7,3.1,8.9,7.8,8.9H174c4.7,0,8.5-4.2,7.8-8.9
        C177.5,145.4,153,123.7,123.4,123.7z"/>
      <path class="st2" d="M65.6,173.8L65.6,173.8c4.2-28.1,28.5-49.7,57.9-49.7c29.3,0,53.6,21.5,57.9,49.7c0.6,4.4-2.9,8.3-7.3,8.3
        H72.9C68.4,182.1,64.9,178.2,65.6,173.8z"/>
    </g>
    <g>
      <path class="st1" d="M123.4,110.7c16.8,0,30.4-13.6,30.4-30.3c0-16.7-13.6-30.3-30.4-30.3S93.1,63.6,93.1,80.3
        C93.1,97.1,106.7,110.7,123.4,110.7z"/>
      <path class="st2" d="M153.3,80.3c0,16.5-13.4,29.8-29.9,29.8S93.6,96.8,93.6,80.3c0-16.5,13.4-29.8,29.9-29.8
        S153.3,63.9,153.3,80.3z"/>
    </g>
    <g>
      <path class="st1" d="M71.2,128.6c-19.3,0-35.3,14.2-38.1,32.7c-0.5,3.1,2,5.8,5.1,5.8h66c3.1,0,5.6-2.7,5.1-5.8
        C106.5,142.8,90.5,128.6,71.2,128.6z"/>
      <path class="st2" d="M33.6,161.4L33.6,161.4c2.8-18.3,18.6-32.3,37.6-32.3c19.1,0,34.9,14,37.6,32.3c0.4,2.8-1.8,5.2-4.6,5.2h-66
        C35.4,166.6,33.1,164.1,33.6,161.4z"/>
    </g>
    <g>
      <path class="st1" d="M71.2,120.6c10.9,0,19.8-8.9,19.8-19.8C91,89.9,82.1,81,71.2,81c-10.9,0-19.8,8.9-19.8,19.8
        C51.3,111.7,60.2,120.6,71.2,120.6z"/>
      <path class="st2" d="M90.5,100.8c0,10.7-8.7,19.3-19.3,19.3s-19.3-8.6-19.3-19.3c0-10.7,8.7-19.3,19.3-19.3S90.5,90.1,90.5,100.8z"
        />
    </g>
    <g>
      <path class="st1" d="M175.2,128.6c-19.3,0-35.3,14.2-38.1,32.7c-0.5,3.1,2,5.8,5.1,5.8h66c3.1,0,5.6-2.7,5.1-5.8
        C210.5,142.8,194.5,128.6,175.2,128.6z"/>
      <path class="st2" d="M137.6,161.4L137.6,161.4c2.8-18.3,18.6-32.3,37.6-32.3c19.1,0,34.9,14,37.6,32.3c0.4,2.8-1.8,5.2-4.6,5.2h-66
        C139.4,166.6,137.1,164.1,137.6,161.4z"/>
    </g>
    <g>
      <path class="st1" d="M175.2,120.6c10.9,0,19.8-8.9,19.8-19.8c0-10.9-8.9-19.8-19.8-19.8c-11,0-19.8,8.9-19.8,19.8
        C155.3,111.7,164.2,120.6,175.2,120.6z"/>
      <path class="st2" d="M194.5,100.8c0,10.7-8.7,19.3-19.3,19.3c-10.7,0-19.3-8.6-19.3-19.3c0-10.7,8.7-19.3,19.3-19.3
        C185.8,81.5,194.5,90.1,194.5,100.8z"/>
    </g>
  </svg>
</template>

<style type="text/css">
  .st0{fill:#686868;}
  .st1{fill:#FFFFFF;}
  .st2{fill:none;stroke:#FFFFFF;stroke-opacity:0.16;}
</style>

<script>
  export default {
    name: 'MultipleAccountIcon'
  };
</script>
    